export { Skeleton, type SkeletonProps } from './styled/skeleton'
